import {Injectable} from '@angular/core';
import {ModalController, Platform} from '@ionic/angular';
import {GesturePassComponent} from '../modals/gesture-pass/gesture-pass.component';
import * as moment from 'moment';
import {GlobalVariable} from '../config/variable';
import {AppnativeProvider} from './appnative.provider';
import {GreetBookComponent} from '../modals/greet-book/greet-book.component';
import {AppUserService} from '../services/app-user.service';
import {LoginModalComponent} from '../pages/login-modal/login-modal.component';
import {ActivatedRoute} from "@angular/router";
import {environment} from "../../environments/environment";

@Injectable({providedIn: 'root'})
export class GestureProvider {
  globalVariable = GlobalVariable;
  gestureModal: any;

  constructor(private platform: Platform,
              private modalController: ModalController,
              private appnativeProvider: AppnativeProvider,
              private activeRouter: ActivatedRoute,
              private appUserService: AppUserService) {
  }

  // 显示手势密码 recorder check
  showGestureModal(type, isShowForgest, isShowClose, isUpdateGesturePass?: boolean): Promise<any> {
    return new Promise(resolve => {
      if (!this.gestureModal) {
        this.gestureModal = this.modalController.create({
          component: GesturePassComponent,
          componentProps: {
            type,
            isShowForgest,
            isShowClose,
            isUpdateGesturePass
          },
          mode: 'ios'
        }).then((modal: any) => {
          this.gestureModal = modal;
          this.gestureModal.present();
          modal.onWillDismiss().then((data, role) => {
            this.gestureModal = null;
            this.appnativeProvider.alertUpdateInfo();
            resolve(data.role);
          });
        });
      }
    });
  }

  // 呼出手势密码
  callGestureModal() {
    const pauseTime = moment(localStorage.getItem('pauseTime'));
    if (moment().diff(pauseTime) > this.globalVariable.gestureResumeTime && localStorage.getItem('_gesture') != null) {
      this.showGestureModal('check', true, false);
    }
  }


  // 知情同意
  showGreetModal = () => new Promise((reslove: any) => {
    this.appUserService.GetFirstLoginConsentArticle({
      UserId: this.globalVariable.currentAccountInfo.staffId,
      ParaID: 'FIRST_LOGIN_CONSENT_ARTICLE',
      Platform: 'APP'
    }).subscribe((r: any) => {
      console.log('-----------------', r);
      if (r.isConsent) {
        reslove('save');
        return;
      }
      this.modalController.create({
        component: GreetBookComponent,
        componentProps: {
          content: r.paraContent
        },
        mode: 'ios'
      }).then((modal: any) => {
        modal.present();
        modal.onWillDismiss().then((data, role) => {
          reslove(data.role);
        });
      });

    });
  })

  GetUserEmail = () => new Promise((reslove: any) => {
    this.activeRouter.queryParams.subscribe(queryParams => {
      const corpid = environment.variables.corpId;
      const code = queryParams.code; // 腾讯的授权code
    });
  });

  // 企业微信LDAP登录
  showLdapLoginModal = () => new Promise((reslove: any) => {
    this.modalController.create({
      component: LoginModalComponent,
      componentProps: {},
      mode: 'ios'
    }).then((modal: any) => {
      modal.present();
      modal.onWillDismiss().then((data, role) => {
        reslove({data, role});
      });
    });
  })
}
